import * as React from "react";
import { FlightHiddenSearchDataProps } from "../typings";
import { observer } from "mobx-react";

export const FlightHiddenSearchData = observer((props: FlightHiddenSearchDataProps) => {
  return (
    <div>
      <input type="hidden" name="flight-type" data-testid="flight-type" value={props.flightType} />
      <input type="hidden" name="mode" data-testid="flight-mode" value={props.mode} />
      <input type="hidden" name="trip" data-testid="flight-triptype" value={props.trip} />
      <input type="hidden" name="leg1" data-testid="flight-leg1" value={props.leg1} />
      <input type="hidden" name="options" data-testid="flight-class" value={props.flightClass} />
      {props.leg2 && <input type="hidden" name="leg2" data-testid="flight-leg2" value={props.leg2} />}
    </div>
  );
});
